<template>
  <div class="form-group mt-auto">
    <div class="custom-dropdown">
      <div class="form-control" @click="toggleDropdown" :style="{border: '1px solid '+color, padding: '.1rem .50rem !important',  marginTop: '-10px'}" :class="className">
        <span 
          v-if="selectedEmoji" 
          style="font-size: 20px" 
          v-html="selectedEmoji"
          :title="titleSelectedEmoji"
        ></span>
        <span v-else style="padding: 2px;">{{ $t(placeholder) }}</span>
      </div>
      <div v-if="showDropdown && right" class="emoji-picker-container">
        <div class="emoji-row" v-for="(row, rowIndex) in emojiRows" :key="rowIndex">
          <div 
            v-for="icon in row" 
            :key="icon.id" 
            v-html="icon.value" 
            @click="onSelectEmoji(icon.value, icon[locale])"  
            class="emoji-item"
            :title="icon[locale]">
          </div>
        </div>
        <div class="text-center py-1" @click="resetEmoji" :style="{backgroundColor: Theme['gray-200'], borderRadius: '5px'}">
          {{ $t('pipelines.reset') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import { ref, computed, watch, nextTick } from "vue";
import {useStore} from "vuex";
import { Theme } from "@/composables/theming";
import {useLocales} from "@/composables/locales";

const props = defineProps({
  color: String,
  placeholder: {
    type: String,
    default: 'select_icon'
  },
  className: String,
  icon: String,
  right: Boolean
});

const store = useStore()
const emits = defineEmits(['emoji'])
const { locale } = useLocales()

const showDropdown = ref(false);
const selectedEmoji = ref(props.icon);

const feelings = computed(() => store.getters['pipelines/pipelineFeelingEnum'])
const titleSelectedEmoji = computed(() => {
  let elt = feelings.value?.filter((item) => {
    return item.value == selectedEmoji.value
  })[0]
  return elt ? elt[locale.value] : ''
})

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
};

const onSelectEmoji = (emoji, title) => {
  selectedEmoji.value = emoji;
  titleSelectedEmoji.value = title;
  emits('emoji', emoji)
  showDropdown.value = false;
};

const emojiRows = computed(() => {
  const rows = [];
  const emojisPerRow = 5;

  for (let i = 0; i < feelings.value.length; i += emojisPerRow) {
    rows.push(feelings.value.slice(i, i + emojisPerRow));
  }

  return rows;
});

function resetEmoji(){
  selectedEmoji.value = ''
  titleSelectedEmoji.value = '';
  emits('emoji', selectedEmoji.value)
  showDropdown.value = false;
}
</script>

<style scoped>
.custom-dropdown {
  position: relative;
}

.emoji-picker-container {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  background: white;
  padding: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  border-radius: 8px;
}

.emoji-row {
  display: flex;
  justify-content: space-around;
  margin-bottom: 5px;
}

.emoji-item {
  cursor: pointer;
  font-size: 25px;
  display: inline-block;
  transition: transform 0.5s ease-in-out;
}


.emoji-item:hover {
  transform: scale(1.5) rotate(360deg);
}
</style>
